import React, { Fragment, useState } from "react";
import { Redirect } from "react-router-dom";

import Header from "../components/Header";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import { Animated } from "react-animated-css";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import { ArrowRightAlt } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: "5px",
    marginTop: "4%",
    backgroundColor: "#FFFFFF",
    height: "auto",
    border: "1px solid #CCCCCC",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.14)",
    width: "90%",
    padding: "0 50px 50px 50px",
    overflow: "hidden",
  },
  next: {
    verticalAlign: "middle",
  },
  textBotom: {
    padding: "10px",
    background: "#000",
    color: "#F7F00B",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
  },
}));

const ColorLinearProgress = withStyles({
  colorPrimary: {
    backgroundColor: "#F7F00B",
  },
  barColorPrimary: {
    backgroundColor: "#000000",
  },
})(LinearProgress);

export default function IndexPerfil() {
  const classes = useStyles();
  const [loaderLoginNegocio, setLoaderLoginNegocio] = useState(false);
  const [loaderLoginDelivery, setLoaderLoginDelivery] = useState(false);
  const [loader, setLoader] = useState(false);
  const [verLoginNegocio, setVerLoginNegocio] = useState(false);
  const [verLoginDelivery, setVerLoginDelivery] = useState(false);

  const handleLoginNegocio = () => {
    setLoaderLoginNegocio(true);
    setLoader(true);
    setTimeout(() => {
      setVerLoginNegocio(true);
    }, 2000);
  };

  const handleLoginDelivery = () => {
    setLoaderLoginDelivery(true);
    setLoader(true);
    setTimeout(() => {
      setVerLoginDelivery(true);
    }, 2000);
  };

  if (verLoginNegocio) {
    return <Redirect to="/loginNegocio" />;
  }

  if (verLoginDelivery) {
    return <Redirect to="/loginDelivery" />;
  }

  return (
    <Fragment>
      <Header />

      <Container maxWidth="lg" className={classes.container}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ marginTop: "50px", marginBottom: "40px" }}
        >
          <Typography
            variant="h5"
            style={{
              color: "#232321",
              fontFamily: '"Yanone Kaffeesatz", Sans-serif',
              letterSpacing: "1.5px",
              fontWeight: "600",
            }}
            align="center"
          >
            Selecciona su perfil
          </Typography>
        </Grid>

        <Animated
          animationIn="bounceIn"
          animationInDuration={2000}
          isVisible={true}
        >
          <Grid
            container
            spacing={1}
            style={loader ? { opacity: "0.4" } : null}
          >
            <Grid item xs={12} sm={6} style={{ padding: "25px" }}>
              <Card className={classes.root}>
                <CardActionArea
                  onClick={handleLoginDelivery}
                  style={{ background: "#F7F00B" }}
                >
                  <center>
                    <CardMedia
                      component="img"
                      alt="delivery"
                      image="../../images/food-delivery-monochrome-800px.png"
                      style={{
                        width: "30%",
                        padding: "40px",
                        objectFit: "cover",
                      }}
                    />
                  </center>
                </CardActionArea>
                <Typography
                  variant="h6"
                  className={classes.textBotom}
                  align="center"
                >
                  Delivery <ArrowRightAlt className={classes.next} />
                </Typography>
                {loaderLoginDelivery ? <ColorLinearProgress /> : ""}
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} style={{ padding: "25px" }}>
              <Card className={classes.root}>
                <CardActionArea
                  onClick={handleLoginNegocio}
                  style={{ background: "#F7F00B" }}
                >
                  <center>
                    <CardMedia
                      component="img"
                      className={classes.media}
                      alt="negocio"
                      image="../../images/storefront-monochrome-800px.png"
                      style={{
                        width: "33%",
                        padding: "40px",
                        objectFit: "cover",
                      }}
                    />
                  </center>
                </CardActionArea>
                <Typography
                  variant="h6"
                  className={classes.textBotom}
                  align="center"
                >
                  Negocio <ArrowRightAlt className={classes.next} />
                </Typography>
                {loaderLoginNegocio ? <ColorLinearProgress /> : ""}
              </Card>
            </Grid>
          </Grid>
        </Animated>
      </Container>
    </Fragment>
  );
}
